import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['button', 'indicator', 'priceMonthly', 'priceYearly'];

  connect() {
    this.state = false;
    this.update();
  }

  toggle() {
    this.state = !this.state;
    this.update();
  }

  update() {
    if (this.state) {
      this.indicatorTarget.classList.add('translate-x-5');
      this.indicatorTarget.classList.remove('translate-x-0');

      this.priceMonthlyTargets.forEach((target) => {
        target.style.display = 'none';
      });

      this.priceYearlyTargets.forEach((target) => {
        target.style.display = '';
      });
    } else {
      this.indicatorTarget.classList.remove('translate-x-5');
      this.indicatorTarget.classList.add('translate-x-0');

      this.priceMonthlyTargets.forEach((target) => {
        target.style.display = '';
      });

      this.priceYearlyTargets.forEach((target) => {
        target.style.display = 'none';
      });
    }
  }
}
